import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Clock, Zap, Cookie, BatteryLow } from 'lucide-react';
export function EmpathySection() {
  return <section className="py-16 md:py-20 bg-white px-4" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <FadeInSection data-id="element-96">
          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-97">
            <p data-id="element-98">Conozco perfectamente esa sensación de frustración.</p>
            <p data-id="element-99">
              Son las 3 de la tarde, estás frente a la computadora o terminando
              tus tareas, y de repente, tu cuerpo te exige algo dulce a gritos.
            </p>
          </div>

          <div className="my-10 bg-amber-50 rounded-2xl p-8 border border-amber-100" data-id="element-100">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-2" data-id="element-101">
              <div className="flex flex-col items-center text-center w-28" data-id="element-102">
                <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-2" data-id="element-103">
                  <Clock className="w-8 h-8 text-amber-600" data-id="element-104" />
                </div>
                <span className="text-sm font-bold text-amber-800" data-id="element-105">
                  3:00 PM
                </span>
                <span className="text-xs text-amber-600" data-id="element-106">Bajón de energía</span>
              </div>

              <svg className="w-8 h-8 text-amber-300 hidden sm:block flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-107">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-108" />
              </svg>
              <svg className="w-8 h-8 text-amber-300 sm:hidden rotate-90 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-109">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-110" />
              </svg>

              <div className="flex flex-col items-center text-center w-28" data-id="element-111">
                <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-2" data-id="element-112">
                  <Cookie className="w-8 h-8 text-red-500" data-id="element-113" />
                </div>
                <span className="text-sm font-bold text-red-700" data-id="element-114">Antojo</span>
                <span className="text-xs text-red-500" data-id="element-115">Necesitas azúcar</span>
              </div>

              <svg className="w-8 h-8 text-amber-300 hidden sm:block flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-116">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-117" />
              </svg>
              <svg className="w-8 h-8 text-amber-300 sm:hidden rotate-90 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-118">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-119" />
              </svg>

              <div className="flex flex-col items-center text-center w-28" data-id="element-120">
                <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mb-2" data-id="element-121">
                  <Zap className="w-8 h-8 text-orange-500" data-id="element-122" />
                </div>
                <span className="text-sm font-bold text-orange-700" data-id="element-123">Culpa</span>
                <span className="text-xs text-orange-500" data-id="element-124">Te sientes mal</span>
              </div>

              <svg className="w-8 h-8 text-amber-300 hidden sm:block flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-125">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-126" />
              </svg>
              <svg className="w-8 h-8 text-amber-300 sm:hidden rotate-90 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-127">
                <path d="M5 12h14M13 5l7 7-7 7" data-id="element-128" />
              </svg>

              <div className="flex flex-col items-center text-center w-28" data-id="element-129">
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mb-2" data-id="element-130">
                  <BatteryLow className="w-8 h-8 text-gray-500" data-id="element-131" />
                </div>
                <span className="text-sm font-bold text-gray-700" data-id="element-132">Agotado</span>
                <span className="text-xs text-gray-500" data-id="element-133">Sin energía</span>
              </div>
            </div>
            <p className="text-center text-sm text-amber-700 mt-5 font-medium italic" data-id="element-134">
              ¿Te suena familiar este ciclo de cada tarde?
            </p>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-135">
            <p data-id="element-136">
              Intentas resistirte. Te dices a ti mismo que esta vez serás fuerte
              y no caerás en la tentación.
            </p>
            <p data-id="element-137">
              Pero la ansiedad es abrumadora. Sientes que no tienes fuerza de
              voluntad y que tu mente te traiciona.
            </p>
            <p data-id="element-138">
              Terminas cediendo, comiendo ese snack, y apenas unos minutos
              después, llega la culpa aplastante.
            </p>
            <p data-id="element-139">
              Y peor aún, poco después llega un bajón de energía que te deja
              arrastrándote el resto del día, de mal humor y sin ganas de nada.
            </p>
            <p data-id="element-140">
              Te miras al espejo y te preguntas en silencio: "¿Por qué no puedo
              simplemente controlarme?"
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>;
}